import { UserRole } from "./user-role";
import { UserCompanyInfo } from "./user-company-info";
import { Company } from "../companies/company";

export class User {
  private userkey: string;
  private active: boolean;
  private requiredTerm: boolean;
  private name: string;
  private email: string;
  private _correlatedId: string;
  private userCompanyInfo: UserCompanyInfo;
  private allowedCompanies: Array<Company>;
  private userRoleList: UserRole[];

  public get correlatedId():string{
    return this._correlatedId;
  }
  public set correlatedId(id:string){
    this._correlatedId = id;
  }

  setUserKey(value: string): void {
    this.userkey = value;
  }

  getUserKey(): string {
    return this.userkey;
  }

  isNew(): boolean {
    return !!this.userkey;
  }

  setActivate(value: boolean): void {
    this.active = value;
  }

  isActivate(): boolean {
    return this.active;
  }

  setRequiredTerm(value: boolean): void {
    this.requiredTerm = value;
  }

  isRequiredTerm(): boolean {
    return this.requiredTerm;
  }

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setEmail(value: string): void {
    this.email = value;
  }

  getEmail(): string {
    return this.email;
  }

  setUserCompanyInfo(value: UserCompanyInfo): void {
    this.userCompanyInfo = value;
  }

  getUserCompanyInfo(): UserCompanyInfo {
    return this.userCompanyInfo;
  }

  setAllowedCompanies(value: Array<Company>): void {
    this.allowedCompanies = value;
  }

  getAllowedCompanies(): Array<Company> {
    return this.allowedCompanies;
  }

  setUserRoleList(value: UserRole[]): void {
    this.userRoleList = value;
  }

  getUserRoleList(): UserRole[] {
    return this.userRoleList;
  }

  hasPermission(permission: string): boolean {
    for (let i = 0; i < this.userRoleList.length; i++) {
      const userRole = this.userRoleList[i];
      const userPermissionList = userRole.getUserPermissionList();
      for (let j = 0; j < userPermissionList.length; j++) {
        if (permission === userPermissionList[j].getCode()) {
          return true;
        }
      }
    }
    return false;
  }

  isUnknownUser(): boolean {
    return false;
  }

  isAdministrator(): boolean {
    return this.userRoleList && this.getUserRoleList()[0].isAdministratorRole();
  }

  isManager(): boolean {
    return this.userRoleList && this.getUserRoleList()[0].isManagerRole();
  }

  isCompanyManager(): boolean {
    return this.userRoleList && this.getUserRoleList()[0].isCompanyManagerRole();
  }

  getCompanyFiscalNumber(): Array<string> {
    let data: Array<string> = [];
    this.allowedCompanies.forEach((uci) => {
      data.push(uci.getFiscalNumber());
    });
    return data;
    //return this.userCompanyInfo && this.getUserCompanyInfo().getFiscalNumber();
  }
}

export class UnknownUser extends User {
  isUnknownUser(): boolean {
    return true;
  }

  hasPermission(permission: string): boolean {
    return false;
  }
}
